import { createSlice } from "@reduxjs/toolkit";
import dateFormat from "dateformat";
import { onSetError, onSetLoaded, onSetLoadedUpdate, onErrorUpdate } from "../utils/loadedError";

const initialAgentsState = {
  data: [],
  // filteredData: [],
  Error: null,
  isLoaded: false,
  selectedWellbores: [],
  selectedTypes: [],
  showOnlyActive: false,
  showOnlyCheckedWellbores: false,
  searchQuery: "",
  stats: {
    total: 0,
    active: 0,
    offline: 0,
  },
  // isLoadedUpdate: true,
  // errorUpdate: null,
  selectedAgentIds: [], // multi-select
  selectedAgents: [],

  agentCommands: {}, //  { agent_id: [] }
  commandsLoading: {},
  commandsError: {},
};

const agentsSlice = createSlice({
  name: "agents",
  initialState: initialAgentsState,
  reducers: {
    onClearStore(state) {
      state.data = [];
      // state.filteredData = [];
      state.Error = null;
      state.isLoaded = false;
      state.selectedWellbores = [];
      state.selectedTypes = [];
      state.showOnlyActive = false;
      state.showOnlyCheckedWellbores = false;
      state.searchQuery = "";
      state.stats = { total: 0, active: 0, offline: 0 };
    },
    onClearFilter(state) {
      // state.filteredData = state.data;
      state.selectedWellbores = [];
      state.selectedTypes = [];
      state.showOnlyActive = false;
      state.showOnlyCheckedWellbores = false;
      state.searchQuery = "";
    },

    addUpdateAgent(state, action) {
      const index = state.data.findIndex((a) => a.agent_id === action.payload.agent_id);
      if (index === -1) {
        state.data.push(action.payload);
      } else {
        state.data[index] = action.payload;
      }
    },

    onInitialAgents(state, action) {
      const newData = [];
      action.payload.forEach((item) => {
        newData.push({
          ...item,
          lastDate: item.lastDate ? dateFormat(item.lastDate, "yyyy-mm-dd HH:MM:ss") : item.lastDate,
        });
      });
      state.data = newData;
      // state.filteredData = filterAgents(state.data, state.selectedWellbores, state.selectedTypes, state.showOnlyActive, state.searchQuery);
      state.isLoaded = true;
      state.Error = null;
      state.stats = calculateStats(state.data);
    },

    deleteDataSuccess(state, action) {
      const id = action.payload;
      state.data = state.data
        .filter((item) => item.id !== id)
        .map((item) => ({
          ...item,
          lastDate: item.lastDate ? dateFormat(item.lastDate, "yyyy-mm-dd HH:MM:ss") : item.lastDate,
        }));
    },

    onSetLoaded,
    // onSetError,
    onSetError(state, action) {
      state.Error = action.payload;
      state.isLoaded = true;
    },
    onSetLoadedUpdate,
    onErrorUpdate,

    // updateAgentStatus(state, action) {
    //   const { agent_id, status, lastDate, lastCommand } = action.payload;
    //   state.data = state.data.map((agent) => {
    //     if (agent.agent_id === agent_id) {
    //       const updatedAgent = { ...agent };
    //       if (status) updatedAgent.status = status;
    //       if (lastDate) updatedAgent.lastDate = lastDate;
    //       if (lastCommand) updatedAgent.lastCommand = lastCommand;
    //       return updatedAgent;
    //     }
    //     return agent;
    //   });

    //   state.filteredData = filterAgents(state.data, state.selectedWellbores, state.selectedTypes, state.showOnlyActive, state.searchQuery);

    //   state.stats = calculateStats(state.filteredData);
    // },

    setSelectedWellbores(state, action) {
      state.selectedWellbores = action.payload;
    },

    setSelectedTypes(state, action) {
      state.selectedTypes = action.payload;
    },

    setShowOnlyActive(state, action) {
      state.showOnlyActive = action.payload;
    },
    setShowOnlyCheckedWellbores(state, action) {
      state.showOnlyCheckedWellbores = action.payload;
    },

    setSearchQuery(state, action) {
      state.searchQuery = action.payload;
    },

    setSelectedAgents(state, action) {
      const { agent_ids, agents } = action.payload;
      state.selectedAgentIds = agent_ids;
      state.selectedAgents = agents;
    },

    clearSelectedAgents(state) {
      state.selectedAgentIds = [];
      state.selectedAgents = [];
    },

    // addSelectedAgent(state, action) {
    //   const { agent_id, agent } = action.payload;
    //   if (!state.selectedAgentIds.includes(agent_id)) {
    //     state.selectedAgentIds.push(agent_id);
    //     state.selectedAgents.push(agent);
    //   }
    // },

    // removeSelectedAgent(state, action) {
    //   const agent_id = action.payload;
    //   const index = state.selectedAgentIds.indexOf(agent_id);
    //   if (index > -1) {
    //     state.selectedAgentIds.splice(index, 1);
    //     state.selectedAgents.splice(index, 1);
    //   }
    // },

    onSetCommandLoaded(state, action) {
      const { agent_id, value } = action.payload;
      state.commandsLoading[agent_id] = value;
    },
    onCommandsFetchError(state, action) {
      const { agent_id, error } = action.payload;
      state.commandsLoading[agent_id] = false;
      state.commandsError[agent_id] = error;
    },
    setAgentCommands(state, action) {
      const { agent_id, commands } = action.payload;
      debugger
      state.agentCommands[agent_id] = commands;
      state.commandsLoading[agent_id] = false;
    },
    addAgentCommand(state, action) {
      const [agent_id, command] = action.payload;
      if (!state.agentCommands[agent_id]) {
        state.agentCommands[agent_id] = [];
      }
      state.agentCommands[agent_id].push(command);
    },
    deleteAllCommands(state, action) {
      action.payload.forEach(({ agent_id }) => {
        if (state.agentCommands[agent_id]) {
          state.agentCommands[agent_id] = [];
        }
      });
    },
  },
});

const calculateStats = (agents) => {
  const total = agents.length;
  const active = agents.filter((agent) => agent.status === "active").length;
  const offline = agents.filter((agent) => agent.status === "offline").length;

  return { total, active, offline };
};

export const getSelectedAgentsCommands = (selectedAgentIds, agentCommands) => {
  // return selectedAgentIds.flatMap((id) => agentCommands[id] || []);
  if (!selectedAgentIds || selectedAgentIds.length === 0) {
    return [];
  }

  return selectedAgentIds.reduce((allCommands, agent_id) => {
    if (agentCommands[agent_id]) {
      return [...allCommands, ...agentCommands[agent_id]];
    }
    return allCommands;
  }, []);
};

export const agentsActions = agentsSlice.actions;
export default agentsSlice.reducer;
